import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Paper,
  Button,
  Typography
} from '@mui/material';
import AnnouncementIcon from '@mui/icons-material/Announcement';

const WorkspaceConversationsDialog = ({ open, workspace, onClose }) => {
  if (!workspace) {
    return null;
  }

  const conversations = Array.isArray(workspace.conversations) ? workspace.conversations : [];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'var(--wb-bg-surface)',
          border: '1px solid var(--wb-border-16)'
        }
      }}
    >
      <DialogTitle sx={{ color: 'var(--wb-text-title)' }}>Conversaciones el espacio de análisis</DialogTitle>
      <DialogContent dividers sx={{ borderColor: 'var(--wb-border)' }}>
        <Paper
          elevation={0}
          sx={{
            bgcolor: 'var(--wb-bg-card)',
            p: 2,
            borderRadius: 2,
            mb: 3,
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <AnnouncementIcon sx={{ color: 'var(--wb-primary)' }} />
          </Box>
          <Typography variant="body2" color="var(--wb-text-strong)">
            En él siguiente listado se muestran las conversaciones (chats) incluidos en el Espacio de Análisis.
            Esto permite organizar las conversaciones en un lugar unificado qe le brinda acceso a los modelos configurados en este Espacio de Análisis.
            Conforme el usuario cree conversaciones en el Espacio de analisis, estas se irán agregando al presente listado.
          </Typography>
        </Paper>

        {conversations.length === 0 ? (
          <Typography sx={{ color: 'var(--wb-muted-80)' }}>
            Este espacio de análisis aún no tiene conversaciones asociadas.
          </Typography>
        ) : (
          <List dense disablePadding>
            {conversations.map((conversationId) => (
              <ListItem
                key={conversationId}
                sx={{
                  borderRadius: 1,
                  border: '1px solid var(--wb-border)',
                  mb: 1,
                  bgcolor: 'var(--wb-x-bg-94a3b80a, rgba(148,163,184,0.04))'
                }}
              >
                <ListItemText
                  primary={
                    <Typography sx={{ color: 'var(--wb-text)', fontFamily: 'monospace' }}>
                      {conversationId}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} sx={{ color: 'var(--wb-muted)' }}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

WorkspaceConversationsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  workspace: PropTypes.object,
  onClose: PropTypes.func.isRequired
};

WorkspaceConversationsDialog.defaultProps = {
  workspace: null
};

export default WorkspaceConversationsDialog;
